import useShortcut from './hooks.mjs';

function Shortcut(props) {
  const {
    ordered,
    onMatch,
    ...rest
  } = props;
  useShortcut(ordered, onMatch, { ...rest
  });
  return null;
}

export { Shortcut as default };
